module.exports = __webpack_public_path__ + "media/images/fair_smiley_selected-14ca56184d2762a4312ee802b2ea5364.svg";